import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import { ZoomableImage } from '../../_core/_ui/zoomable-image.component';
import { IFormOption } from '../../_core/_ui/forms.component';
import { isBandedTemplate } from '../../../lib/helpers/format-template.helpers';
import { FormatTemplateBandSummary } from '../format-template-band-summary.component';
import { FormatTemplatePills } from '../format-template-pills.component';
import { FormatTemplateStageList } from '../format-template-stage-list.component';
import { messages } from '../format-template.messages';

interface IPreviewTemplateModalProps {
  open: boolean;
  onClose: () => void;
  template: IFormatTemplate | null;
  stages: IAssessmentStage[];
  drillOptions: IFormOption[];
  practicePlanOptions: IFormOption[];
  positionOptions: IFormOption[];
  loading: boolean;
}

export const PreviewTemplateModal: React.FC<IPreviewTemplateModalProps> = ({
  open,
  onClose,
  template,
  stages,
  drillOptions,
  practicePlanOptions,
  positionOptions,
  loading,
}) => {
  if (!template) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{template.name}</DialogTitle>
      <DialogContent>
        <ZoomableImage src={template.imageUrl} alt={template.name} />

        <Box mb={2}>
          <FormatTemplatePills template={template} showAgeGroups />
        </Box>

        {isBandedTemplate(template) ? (
          <FormatTemplateBandSummary bands={template.bands ?? []} />
        ) : (
          <FormatTemplateStageList
            stages={stages}
            drillOptions={drillOptions}
            practicePlanOptions={practicePlanOptions}
            positionOptions={positionOptions}
            loading={loading}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary"><IntlMsg {...messages.close} /></Button>
      </DialogActions>
    </Dialog>
  );
};
